document.addEventListener('DOMContentLoaded', function () {
  setupSafeDrapesFilters();
});

function setupSafeDrapesFilters() {
  // Only desktop
  if (window.innerWidth < 750) return;

  const filters = document.querySelectorAll(
    '.facets-container .facets__disclosure-vertical'
  );

  filters.forEach(function (filter) {
    // Open every filter by default
    filter.setAttribute('open', '');

    // Prevent duplicate listeners
    if (filter.dataset.safeDrapesReady === 'true') return;

    filter.dataset.safeDrapesReady = 'true';

    const summary = filter.querySelector(':scope > summary');

    if (!summary) return;

    summary.addEventListener('click', function () {
      // Native <details> handles open/close automatically.
      // We only keep the accordion behavior.
    });
  });
}

// Shopify AJAX filter refresh
document.addEventListener('shopify:section:load', function () {
  setupSafeDrapesFilters();
});

// Also handle browser resize
window.addEventListener('resize', function () {
  setupSafeDrapesFilters();
});